import '../static/major/scss/reviews.scss';

import './profile-pages/reviews';
